import React from "react";
import { NessieThemeProvider } from "@classdojo/web";
import { CloseIcon as NessieCloseIcon } from "@classdojo/web";

export const CloseIcon = (props: any) => {
  return (
    <NessieThemeProvider>
      <NessieCloseIcon {...props} />
    </NessieThemeProvider>
  );
};
